import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const ModalBuilder = () => (
  <ComponentDocs
    name="<ModalBuilder/>"
    entry="ModalBuilder"
    propsEntry="ModalBuilderProps"
  >
    <ComponentExample
      name="Basic modal"
      import={import("examples/Builders/ModalBuilder/BasicModalExample")}
      rawImport={import("examples/Builders/ModalBuilder/BasicModalExample?raw")}
    />
    <ComponentExample
      name="Modal loading data"
      import={import("examples/Builders/ModalBuilder/ModalLoadingDataExample")}
      rawImport={import(
        "examples/Builders/ModalBuilder/ModalLoadingDataExample?raw"
      )}
    />
    <ComponentExample
      name="Modal with form"
      import={import("examples/Builders/ModalBuilder/ModalWithFormExample")}
      rawImport={import(
        "examples/Builders/ModalBuilder/ModalWithFormExample?raw"
      )}
    />
    <ComponentExample
      name="Controlled modal"
      import={import("examples/Builders/ModalBuilder/ControlledModalExample")}
      rawImport={import(
        "examples/Builders/ModalBuilder/ControlledModalExample?raw"
      )}
    />
    <ComponentExample
      name="Keep open after submitting"
      description="After the Submit button is pressed, this modal will reset instead of closing."
      import={import("examples/Builders/ModalBuilder/KeepOpenExample")}
      rawImport={import("examples/Builders/ModalBuilder/KeepOpenExample?raw")}
    />
  </ComponentDocs>
);

export default ModalBuilder;
